import Filtering, { Filter, FilterKey, FilterType } from "../Stats/Filtering/Filtering"

export default class QueryString {

	public static getFilters = (
		query: URLSearchParams,
	) => {

		const filtersParam = query.get('filters')

		if (!filtersParam) {
			return [] as Filter[]
		}

		const filters: Filter[] = []

		for (const filterString of filtersParam.split('|')) {
			const filter = this.parseFilterString(filterString)
			if (filter) {
				filters.push(filter)
			}
		}

		return filters
	}

	public static make = (filters: Filter[]) => {

		const queryStringParts = []

		if (filters.length) {
			const filterStrings = filters.map(filter => this.makeFilterString(filter))
			queryStringParts.push(`filters=${filterStrings.join('|')}`)
		}

		if (queryStringParts.length === 0) {
			return ''
		}

		return `?${queryStringParts.join('&')}`
	}

	private static makeFilterString = (filter: Filter) => {
		return `${filter.key}_${filter.type}_${filter.values.join('_')}`
	}

	private static parseFilterString = (filterString: string) => {

		const parts = filterString.split('_')
		if (parts.length < 3) {
			return null
		}

		const key: FilterKey = parts[0] as FilterKey
		if (Filtering.keys.indexOf(key) === -1) {
			return null
		}

		const type: FilterType = parts[1] as FilterType
		if (['all', 'any', 'exact'].indexOf(type) === -1) {
			return null
		}

		return {
			canChangeType: Filtering.canChangeType(key),
			key,
			type,
			values: parts.slice(2),
		}
	}
}
